import { EventTypes, environment, version } from './AppInsights/constants';
import { WindowGlobal } from '../types/globalTypes';

/**
 * Send custom event to AppInsights
 * @param  {string} component   The reference to the component
 * @returns {void}
 * @hidden
 */
const sendCustomEvent = (component: HTMLElement): void => {
  try {
    (window as WindowGlobal)['AppInsights'].trackEvent(
      {
        name: EventTypes.COMPONENT_REGISTER,
      },
      {
        component: component.tagName.toLowerCase(),
        componentId: component.id,
        environment,
        version,
        host: window.location.host,
      }
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('[APP INSIGHTS] Could not send event', err);
  }
};

/**
 * Add the component to the pipeline and send component events to AppInsights
 * @param   {HTMLElement} component  The component element
 * @returns {void}
 * @hidden
 */
export function add(component: HTMLElement): void {
  (window as WindowGlobal)['ArmDesignSystem'].pipeline.set(component.id, component.tagName.toLowerCase());

  // Disable sending events to AppInsights during unit tests
  if (!(window as WindowGlobal)['ArmDesignSystem'].config.getBoolean('_isTesting')) {
    sendCustomEvent(component);
  }
}

/**
 * Remove the component from the pipeline
 * @param   {HTMLElement} component  The component element
 * @returns {void}
 * @hidden
 */
export function remove(component: HTMLElement): void {
  (window as WindowGlobal)['ArmDesignSystem'].pipeline.delete(component.id);
}
